import React from 'react';
import ReactDOM from 'react-dom';

import { Router, Route, Switch } from "react-router-dom";
import createBrowserHistory from "history/createBrowserHistory";



import './index.css';
import App from './App';
import SignIn from './components/SignIn';
import SignInPage from './components/SignInPage';
import Home from './components/Home';
import Broadcast from './components/Broadcast';
import Listen from './components/Listen';
import registerServiceWorker from './registerServiceWorker';

const history = createBrowserHistory();

//ReactDOM.render(<Home />, document.getElementById('root'));

ReactDOM.render(
    <Router history={history}>
      <Switch>
        <Route exact path="/" component={SignIn} />
        <Route exact path="/SignIn/" component={SignIn} />
        <Route exact path="/SignInPage/" component={SignInPage} />
        <Route exact path="/Home/" component={Home} />
        <Route exact path="/Broadcast/" component={Broadcast} />
        <Route exact path="/Listen/" component={Listen} />
      </Switch>
    </Router>,
    document.getElementById("root")
  );


registerServiceWorker();
 


// WEBPACK FOOTER //
// ./src/index.js